// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyD8dmO1kolQsjdyZlB6N0_Lxi60spP6pX0",
  authDomain: "shingan-lp.firebaseapp.com",
  projectId: "shingan-lp",
  storageBucket: "shingan-lp.appspot.com",
  messagingSenderId: "259019902320",
  appId: "1:259019902320:web:a464004e1b44a2af76d3b5",
  measurementId: "G-WRCPQFBS6B",
};
